var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"loading-wrap"},[_c('md-progress-spinner',{staticClass:"md-accent",attrs:{"md-diameter":100,"md-stroke":10,"md-mode":"indeterminate"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }